'use client';

import {
  sendEvent,
  subscribe,
  unsubscribe,
} from '@unu/ui-common';

import {
  traceError,
} from '@unu/ui-insights';

const context = 'web-native-bridge';

let registeredEvents = {};

const subscribeToEvents = () => {

  for (const [name, callback] of Object.entries(registeredEvents)) {

    if (!name || typeof callback !== 'function') {
      continue;
    }

    subscribe({
      name,
      callback,
      context,
    });
  }
};

export const unregisterEvents = (events = registeredEvents) => {

  if (typeof events !== 'object') {
    return;
  }

  for (const name of Object.keys(events)) {

    if (!name) {
      continue;
    }

    unsubscribe({
      name,
      context,
    });
  }
};

export const registerEvents = events => {

  if (typeof events === 'object') {

    registeredEvents = {
      ...registeredEvents,
      ...events,
    };
  }

  subscribeToEvents();

  return unregisterEvents;
};

const onMessage = data => {

  try {
    sendEvent(data);
  } catch (error) {
    traceError('Error receiving bridge event from native', error);
  }
};

if (typeof window !== 'undefined') {
  window.onNativeBridgeMessage = onMessage;
};
